module.exports = __webpack_public_path__ + "static/img/table.eb0c546.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table.jpg
// module id = S4yX
// module chunks = 1